import { EcoulementsComponent } from './ecoulements.component';

export const ECOULEMENTS_ROUTES = [
    {
        path: '',
        component: EcoulementsComponent,
        data: {
            role: 'ORGANISME || DECLARATION_ECOULEMENT_ECRITURE',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.ecoulements',
                icon: 'key'
            }
        }
    },
    {
        path: ':idEntreprise',
        component: EcoulementsComponent,
        data: {
            role: 'ORGANISME || PI || GP',
            domaines: ['ANPP']
        }
    }
];
